import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import Row from '../../../components/Row';
import Col from '../../../components/Col';
import EditableCheckbox from '../../../components/forms/editableCheckbox';
import {FormattedMessage, FormattedHTMLMessage, intlShape, injectIntl} from 'react-intl';
import {countries} from 'helpers/constants';

class StoreProducts extends PureComponent {
  static propTypes = {
    store: PropTypes.object.isRequired,
    edit: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    dealer: PropTypes.object.isRequired,
  };

  render() {
    const {store, edit, onChange, dealer} = this.props;
    let {formatHTMLMessage} = this.props.intl;

    return <div>
      <h2 className='with-keyline'><FormattedMessage id="general.products" /></h2>
      <Row>
        <Col xs={12}>
          <div className='products'>
            <EditableCheckbox dataKey='bioGuard' value={store.bioGuard}
                              disabled={store.bioGuard && !store.proGuard && !store.spaGuard && !store.naturalChemistry}
                              onChange={onChange} editMode={edit}>
              <FormattedHTMLMessage id='preferences.store.products.bioguard'/>
            </EditableCheckbox>
          </div>
          {dealer.country === countries.US ? <div className='products'>
            <EditableCheckbox dataKey='proGuard' value={store.proGuard}
                              disabled={store.proGuard && !store.bioGuard && !store.spaGuard && !store.naturalChemistry}
                              onChange={onChange} editMode={edit}>
              <FormattedHTMLMessage id='preferences.store.products.proguard'/>
            </EditableCheckbox>
          </div> : null}
          <div className='products'>
            <EditableCheckbox dataKey='spaGuard' value={store.spaGuard}
                              disabled={store.spaGuard && !store.bioGuard && !store.proGuard && !store.naturalChemistry}
                              onChange={onChange} editMode={edit}>
              <FormattedHTMLMessage id='preferences.store.products.spaguard'/>
            </EditableCheckbox>
          </div>
          <div className='products'>
            <EditableCheckbox dataKey='naturalChemistry' value={store.naturalChemistry}
                              disabled={store.naturalChemistry && !store.bioGuard && !store.spaGuard && !store.proGuard}
                              onChange={onChange} editMode={edit}>
              <FormattedHTMLMessage id='preferences.store.products.natural-chemistry'/>
            </EditableCheckbox>
          </div>
        </Col>
      </Row>
    </div>;
  }
}

export default injectIntl(StoreProducts);
